import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Text, TextTypography as TYPOGRAPHY } from 'wix-ui-tpa/cssVars';
import { DataHooks } from './consts';
import { classes, st } from './Title.st.css';
import settingsParams from '../../../settingsParams';

export type TitleProps = {};

export const Title: FC = () => {
  const settings = useSettings();
  const { isMobile } = useEnvironment();
  const tagName = settings.get(settingsParams.titleTagName);
  return (
    <div
      data-hook={DataHooks.WRAPPER}
      className={st(classes.root, {
        isMobile,
      })}
    >
      <Text
        className={classes.title}
        data-hook={DataHooks.TITLE}
        typography={TYPOGRAPHY.largeTitle}
        tagName={tagName}
      >
        {settings.get(settingsParams.titleText)}
      </Text>
    </div>
  );
};
